export default "__VITE_ASSET__B046KgmF__"